function fetchConfig(type = 'json', contentType = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': `application/${contentType}`, 'Accept': `application/${type}` }
  };
}

if(!customElements.get('product-stock-notification')) {
  class ProductStockNotification extends HTMLElement {
    constructor() {
      super();

      this.formElement = this.querySelector('[data-notify-form]');
      this.formElementIsOpenClass = 'product-stock-notification__form--is-open';

      this.inputElement = this.querySelector('[data-notify-input]');
      this.inputInvalidAttribute = 'aria-invalid';

      this.successElement = this.querySelector('[data-notify-success]');
      this.successElementIsOpenClass = 'product-stock-notification__success--is-open';

      this.submitBtn = this.querySelector('[type="submit"]');
      this.isSubmittingClass = 'loading';

      // Add submit event listener
      this.submitBtn.addEventListener('click', this.submit.bind(this));

      // Clear input after change if invalid
      this.inputElement.addEventListener('input', this.clearInputValidation.bind(this));
    }

    async submit(event) {
      event.preventDefault();

      const klaviyoId = this.dataset.klaviyoId;
      const variantId = parseInt(this.dataset.productNotifyVariantId) || null;
      const email = this.inputElement.value.trim();

      // Validate email input before continuing
      // Email validation regex as implemented in the HTML5 input of type email
      const emailRegEx = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

      if (!emailRegEx.test(email)) {
        this.inputElement.setAttribute(this.inputInvalidAttribute, true);
        return false;
      }

      const endpoint = 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe';
      const params = {
        a: klaviyoId,
        email: email,
        variant: variantId,
        platform: "shopify"
      };

      try {
        this.submitBtn.classList.add(this.isSubmittingClass);
        this.submitBtn.disabled = true;

        const response = await fetch(endpoint, {
          ...fetchConfig('json', 'x-www-form-urlencoded'),
          body: new URLSearchParams(params),
        });

        if (response.status !== 200) {
          throw new Error(response.status);
        }

        // On success: Hide the form and show the success message
        this.toggleSuccessMessage(true);

      } catch (error) {
        // On error:
        console.error('error submitting to back in stock', error);

      } finally {
        this.submitBtn.classList.remove(this.isSubmittingClass);
        this.submitBtn.disabled = false;
      }
    }

    toggleSuccessMessage(isSuccess = true) {
      if (isSuccess) {
        this.formElement.classList.remove(this.formElementIsOpenClass);
        this.successElement.classList.add(this.successElementIsOpenClass);
      } else {
        this.formElement.classList.add(this.formElementIsOpenClass);
        this.successElement.classList.remove(this.successElementIsOpenClass);
      }
    }

    clearInputValidation() {
      if (this.inputElement.getAttribute(this.inputInvalidAttribute) === 'true') {
        this.inputElement.removeAttribute(this.inputInvalidAttribute);
      }
    }
  }

  window.ProductStockNotification = ProductStockNotification;
  customElements.define('product-stock-notification', ProductStockNotification);
}
